import React, { useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ArrowLeft from "./ArrowLeft";
import ArrowRight from "./ArrowRight";
import CalendarIcon from "./CalendarIcon";
import { format, addMonths, subMonths } from "date-fns";
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const CalendarPicker = ({ selectedDate, setSelectedDate }) => {
    const [open, setOpen] = useState(false);
    const onClose = () => setOpen(false)
    const doggleOpen = () => setOpen(!open)

    const handlePrevMonth = () => {
        setSelectedDate(subMonths(selectedDate, 1));
    };

    const handleNextMonth = () => {
        setSelectedDate(addMonths(selectedDate, 1));
    };
    const ChangeDate = (dateInpute) => {
        setSelectedDate(dateInpute);
    }

    return (
        <Box display="flex" alignItems="center" gap="5px" marginTop='10px'>
            <IconButton onClick={handlePrevMonth}>
                <ArrowLeft />
            </IconButton>
            <CalendarIcon />
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                    sx={{ visibility: 'hidden', width: '1px' }}
                    open={open}
                    onClose={onClose}
                    value={selectedDate}
                    onChange={ChangeDate}
                    views={['year', 'month']} />
            </LocalizationProvider>
            <Typography sx={{ cursor: 'pointer' }} variant="h5" onClick={doggleOpen}>{format(selectedDate, "MMMM yyyy")}</Typography>
            <IconButton onClick={handleNextMonth}>
                <ArrowRight />
            </IconButton>
        </Box>
    );
};

export default CalendarPicker;
